// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"7f9f7e0e","368":"51c9ac48","420":"96a90ebc","539":"ccdbe5bb","541":"12934f77","644":"eaf3e63d","857":"17d8984c","884":"0fd4a4d6","945":"86f89a40"}[chunkId] + ".js";
};